import './instrument';
import '@ant-design/v5-patch-for-react-19';
/// <reference types="vite-plugin-svgr/client" />
import { ThemeProvider, createTheme } from '@mui/material';
import { ConfigProvider } from 'antd';
import en_US from 'antd/locale/en_US';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { PersistGate } from 'redux-persist/integration/react';
import { IoProvider } from 'socket.io-react-hook';
import App from './components/App';
import LiveVideo from './components/Conversations/LiveVideo';
import ErrorHandler from './components/ErrorHandler';
import Loader from './components/Loader';
import { DeviceProvider } from './contexts';
import { AuthProvider } from './contexts/auth';
import './index.sass';


import { queryClient } from './reactQuery';
import reportWebVitals from './reportWebVitals';
import store, { persistor } from './store';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <DeviceProvider>
      <Provider store={store}>
        <PersistGate loading={<Loader />} persistor={persistor}>
          <ThemeProvider theme={createTheme()}>
            <ConfigProvider theme={{ token: { colorPrimary: '#083147' } }} locale={en_US}>
              <ErrorBoundary FallbackComponent={ErrorHandler}>
                <QueryClientProvider client={queryClient}>
                  <AuthProvider>
                    <IoProvider>
                      <ToastContainer />
                      <Suspense fallback={<Loader />}>
                        <App />
                      </Suspense>

                      <LiveVideo />
                    </IoProvider>
                  </AuthProvider>
                </QueryClientProvider>
              </ErrorBoundary>
            </ConfigProvider>
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </DeviceProvider>
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
